module.exports = __webpack_public_path__ + "r-v3/img/repeat_one_white.00c89ff9.svg";